<template>
    <div class="content content-fixed content-auth-alt">
        <div class="container d-flex justify-content-center ht-100p">
            <div v-if="auth.tfaScreen === 'reg'" class="mx-wd-300 wd-sm-450 ht-100p d-flex flex-column align-items-center justify-content-center">
                <div class="wd-80p wd-sm-300 mg-b-15">
                    <b-overlay :show="auth.showOverlay" rounded="sm">
                        <qrcode style="padding: 0;" :value="JSON.stringify(auth.twoFa)" :options="{ width: 300 }"></qrcode>
                        <template v-slot:overlay>
                            <div class="text-center">
                                <span  v-if="auth.authLoading" ><b-icon icon="stopwatch" font-scale="3" animation="cylon"></b-icon>
                                <p id="cancel-label">Please wait...</p></span>
                                <b-button
                                        v-if="!auth.authLoading"
                                        ref="cancel"
                                        variant="outline-danger"
                                        size="sm"
                                        aria-describedby="cancel-label"
                                        @click="refresh()"
                                >
                                    Refresh
                                </b-button>
                                <b-button
                                        v-if="auth.authLoading"
                                        ref="cancel"
                                        variant="outline-danger"
                                        size="sm"
                                        disabled
                                        aria-describedby="cancel-label"
                                >
                                    Refresh
                                </b-button>
                            </div>
                        </template>
                    </b-overlay>
                </div>
                <h4 class="tx-20 tx-sm-24">Activate two factor authentication(2FA)</h4>
                <p class="tx-color-03 mg-b-2 tx-left">1. Download QTrust from <a href="#">Google playstore</a> or <a href="#">AppStore</a> </p>
                <p class="tx-color-03 mg-b-2 tx-left">2. Click on Add profile </p>
                <p class="tx-color-03 mg-b-2 tx-left">3. Scan the QR-Code to continue </p>
                <div class="tx-13 mg-t-20 tx-center">Go back to  <router-link to="/">Sign In</router-link></div>
            </div>
            <div v-if="auth.tfaScreen === 'token'" class="mx-wd-300 wd-sm-450 ht-100p d-flex flex-column align-items-center justify-content-center">
                <div class="wd-80p wd-sm-300 mg-b-15"><router-link to="/"><img src="../../assets/img/1.png" class="img-fluid" alt=""></router-link></div>
                <h4 class="tx-20 tx-sm-24">Activate two factor authentication(2FA)</h4>
                <p class="tx-color-03 mg-b-30 tx-center">Please enter the token generated from QTrust</p>
                <two-fa-form></two-fa-form>
            </div>
        </div><!-- container -->
    </div><!-- content -->
</template>

<script>
    import TwoFaForm from "../../components/form/TwoFaForm";
    import {mapState} from 'vuex'
    //import store from "../../store/store";
    export default {
        name: "TwoFa",
        components:{
            TwoFaForm
        },
        data(){
            return{
                show:true
            }
        },
        methods:{
            refresh(){
                this.$store.commit("auth/updateTwoFa", null)
                this.$store.commit("auth/updateAuthLoading", true)
                this.checkTwoFa()
            },
            async checkTwoFa(){
                if (this.auth.tfaScreen === 'reg'){
                    for (let i = 0; i < 20; i++){
                        await this.$store.dispatch("auth/updateTwoFaInfo").then(response => {
                            //this.$store.commit("auth/updateAuthLoading", false);
                            if (response.data.responseCode === "00") {
                                this.$store.commit("auth/updateTfaScreen", "token");
                                //this.$store.commit("auth/authLoading", false);
                                this.$store.commit("auth/updateShowOverlay", false)
                            }else{
                                let payload = {}
                                payload.dialogs = this.$dialogs
                                if (this.auth.twoFa == null)
                                    this.$store.dispatch("auth/generateTwoFa",payload)
                                this.$store.commit("auth/updateTfaScreen", "reg");
                            }
                        })
                    }
                    this.$store.commit("auth/updateShowOverlay", true)
                    console.log(this.auth.showOverlay)
                }
            }
        },
        computed:{
            ...mapState([
                'auth',
                'system'
            ])
        },
        mounted() {
            if (this.system.userInfo != null)
                this.checkTwoFa();
            else
                this.$router.push('/');
        }
    }
</script>

<style scoped>

</style>